module.exports = __webpack_public_path__ + "static/media/case-green.e5138518.png";